module.exports = __webpack_public_path__ + "img/ideation-05-bg-brandvideo.86cd6093.jpg";